import { jsx as _jsx } from "react/jsx-runtime";
import { CatList } from '@blocks-react/components/List';
import { HeaderCartListItem, HeaderCartListItemSkeleton } from './item';
const skeletons = [...new Array(5).keys()];
export const HeaderCartList = ({ items, quantityLabel, isLoading, onItemClick }) => {
    return (_jsx(CatList, { children: isLoading
            ? skeletons.map((key) => (_jsx(HeaderCartListItemSkeleton, {}, `cart-list-item-${key}`)))
            : items.map((item, index) => (_jsx(HeaderCartListItem, { item: item, quantityLabel: quantityLabel, onClick: () => onItemClick(item, index) }, item.orderItemId))) }));
};
